document.addEventListener('DOMContentLoaded', () => {

  // *************************
  // Collection infinite loading
  // Load more products with the load more button beneath the pagination on a PLP
  // *************************
  function loadMoreProducts() {

    const loadMoreURL = document.querySelector('[data-load-more] a').getAttribute('href');
    const pagingEl = document.querySelector('[data-paging]');
    const collectionList = document.querySelector('[data-collection-list]');

    // add display none check after
    if (loadMoreURL.length > 0) {
      // Hide the paging element while we load in the new content
      pagingEl.classList.add('opacity-0');
      fetch(loadMoreURL)
      .then(response => response.text())
      .then(responseText => {
        // Parse the response text
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        // Get the product cards from the next page
        const filteredData = html.querySelectorAll('[data-collection-list] [data-collection-item]');
        // Append these cards to the main collection list
        filteredData.forEach(item => {
          collectionList.append(item);
        });

        // Update the paging area
        const pagingData = html.querySelector('[data-paging]');

        // Let the grid know whether there's still another page after this one, so it knows
        // whether to defer an incomplete last row's products to the next "Load More" batch
        // or just show them (see product-grid.js).
        const hasNextPage = !!(pagingData && pagingData.querySelector('[data-load-more] a'));
        collectionList.dataset.hasNextPage = String(hasNextPage);

        if (pagingData){
          pagingEl.innerHTML = pagingData.innerHTML;
        } else {
          pagingEl.classList.add('hidden');
        }

        // Reveal the paging element again
        pagingEl.classList.remove('opacity-0');

      })
      .catch(e => {
        console.error(e);
      });
    }
  }

  document.addEventListener('click', (event) => {
    const loadMoreButton = event.target.closest('[data-load-more] a');
    if (loadMoreButton) {
      event.preventDefault();
      loadMoreProducts();
      return false;
    }
  });


  document.addEventListener('click', (event) => {

    // clicked on a product card from the PLP?
    const dataEl = event.target.closest('[data-collection-product-item]');
    if (dataEl) {
      // get the page content
      let productGrid = document.getElementById("ProductGridContainer").innerHTML;
      
      // get the current location and scroll
      const 
        location = window.location.href,
        scroll = window.scrollY;
        
      window.history.pushState({data: productGrid, name: 'listing-grid', scroll: scroll}, '', location);
      
    }
  });

  
  


  // product-grid.js dispatches this after it defers an incomplete last row's products to the
  // next "Load More" batch, with the corrected count of products currently visible in the grid.
  // Event name must stay in sync with ThemeEvents.gridOrphanUpdate in assets/events.js - this
  // file isn't a module, so it can't import the constant.
  document.addEventListener('grid:orphan-update', (event) => {
    const { visibleProductCount } = event.detail;
    const desktopCount = document.getElementById('pagingCurrentCountDesktop');
    const mobileCount = document.getElementById('pagingCurrentCount');

    if (desktopCount) desktopCount.textContent = visibleProductCount;
    if (mobileCount) mobileCount.textContent = visibleProductCount;
  });

});